const BETA_ALLOWED_USER_IDS: Set<string> = new Set([
  '2395307', '5233643', '17389088', '1391045', '5357984',
  '2542633', '12846371', '5611097', '7108924', '12941302',
  '25942623', '17633441', '3406920', '6036097', '5283850',
  '18464663', '5446196', '19403333', '21033157', '12937187',
  '399449', '15425514', '26698620', '20165231', '19579882',
  '12671715', '2237213', '67305', '15741133', '17389077',
  '25942660', '26672669'
]);

export function isBetaRestricted(): boolean {
  return window.location.hostname === 'basketball-ai.hudl.com';
}

export function isUserAllowedInBeta(userId: string | null): boolean {
  if (!isBetaRestricted()) return true;
  if (!userId) return false;
  return BETA_ALLOWED_USER_IDS.has(userId);
}
